module.exports = __webpack_public_path__ + "static/illust01_sp-d640bb7db734f3982b8f2b5dd65a0a48.webp";